import React from 'react'
import EyefinitySectionFields from '../EyefinitySectionFields'

export default function Lens(props) {
  return <EyefinitySectionFields {...props} sectionName="lens" title="Lens" />
}
